import useSWR from "swr";
import API from "../../../utils/api";
import { useToken } from "../auth/token";
// import { getPersistData } from '../persist'

// const KEY = MYBALANCE

export function useBalance(symbol?: string, type = 0) {
	const { data: token } = useToken()
	if (symbol === undefined) symbol = 'USDT'
	//let SWRKEY: any = MYBALANCE + '?symbol=' + symbol + '&type=' + type

	let SWRKEY: any = '/trade/status'

	if (!token) SWRKEY = null

	const { data, mutate, error } = useSWR<any>(
		SWRKEY,
		async () => {
			try {
				const response = await API.get(SWRKEY, token + '', {}, false)
				
				// 응답이 에러인 경우 처리
				if (response && response.code && response.code !== 0 && !response.success) {
					console.warn('[useBalance] API returned error:', {
						code: response.code,
						message: response.message,
						url: SWRKEY,
					})
					// 에러 응답이어도 로그아웃하지 않고 null 반환
					return null
				}
				
				return response?.result?.result
			} catch (error) {
				// 에러 발생 시에도 로그아웃하지 않음
				console.error('[useBalance] Balance fetch error:', error)
				return null
			}
		},
		{
			revalidateOnFocus: true,
			revalidateOnReconnect: true,
			revalidateIfStale: true,
			shouldRetryOnError: false, // 에러 발생 시 재시도하지 않음
			onError: (error) => {
				// SWR 에러 핸들러에서도 로그아웃하지 않음
				console.error('[useBalance] SWR balance error:', error)
			},
		}
	)

	const spot = data?.spot
	const futures = data?.futures
	const global = data?.global
	const reward = data?.rewards

	return {
		data: type === 0 ? spot : 
		     type === 1 ? futures : 
		     type === 7 ? reward : 
		     type === 8 ? reward : 
		     type === 9 ? global : 
		     futures,
		mutate: (value?: any) => {
			return mutate()
		},
	}
}
